import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=040bae59&scoped=true&"
import script from "./user-management.vue?vue&type=script&lang=ts&"
export * from "./user-management.vue?vue&type=script&lang=ts&"
import style0 from "./user-management.vue?vue&type=style&index=0&id=040bae59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040bae59",
  null
  
)

export default component.exports